module.exports = __webpack_public_path__ + "static/media/randomPic.521a9008.jpg";